import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-gatorz-policy.js';

const defaultItems = [
  {
    content: `<p style="text-align: center"><strong>FREE SHIPPING ON ORDERS OVER $100</strong></p>
<p style="text-align: center"><span style="color:hsl( 40, 6%, 90% );">Est. 3 - 7 business days</span></p>`,
  },
  {
    content: `<p style="text-align: center"><strong>MILITARY, 1st RESPONDER, MEDICAL AND GOV. EMPLOYEE DISCOUNT</strong></p>
<p style="text-align: center"><span style="color:hsl( 40, 6%, 90% );">Available at checkout. Verification Required.</span></p>`,
  },
  {
    content: `<p style="text-align: center"><strong>TACTICAL BULK ORDERS</strong></p>
<p style="text-align: center"><span style="color:hsl( 40, 6%, 90% );">Start your order <a href="#">here</a>.</span></p>`,
  },
];

const renderPolicyItem = item => `
  <li class="gatorz-policy__item" data-attribute="gatorz-policy__item">
    <div class="gatorz-policy__item-content" data-attribute="gatorz-policy__item-content">
      ${item.content || ''}
    </div>
  </li>`;

const contentHtml = `
  <div class="wrap-gatorz-policy container" data-attribute="gatorz-policy-content">
    <ul class="gatorz-policy__list" data-attribute="gatorz-policy__list">
      ${defaultItems.map(renderPolicyItem).join('')}
    </ul>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#222222',
  textColor: '#ffffff',
  topPadding: true,
  bottomPadding: true,
});
